import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { BackgroundImage } from "../../elements";
import gsap from 'gsap';
import { getOverallSettingsClasses, mobileIs, loadScrollMagic } from "../../utils/siteUtils";

import "./style.scss";
const BalancedDesign = ({ page, lang, rendering, fields }) => {
  const  { pc_image, m_image, list } = fields
  const rootNode = useRef();
	const isMobile = mobileIs()
	const topImageEl = useRef()
	const listContentEl = useRef()
	
	const onScroll = () => {
		let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		const winHeight = window.innerHeight || document.documentElement.clientHeight
		let titleDoms = document.querySelectorAll('.c-balanced-design .item-title')
		let descDoms = document.querySelectorAll('.c-balanced-design .item-desc')
		let imageContentDoms = document.querySelectorAll('.c-balanced-design .background-image-content')
		let imageDoms = document.querySelectorAll('.c-balanced-design .background-image-content .c-background-image')
		 
		for(let i=0; i<imageContentDoms.length; i++) {
			if(imageContentDoms[i].getBoundingClientRect().top < winHeight - 90) {
				imageContentDoms[i].setAttribute('class', 'background-image-content show')
				if(titleDoms[i]) {
					titleDoms[i].setAttribute('class', 'item-title show')
				}
				if(descDoms[i]) {
					descDoms[i].setAttribute('class', 'item-desc show')
				}
			} else {
				imageContentDoms[i].setAttribute('class', 'background-image-content')
				if(titleDoms[i]) {
					titleDoms[i].setAttribute('class', 'item-title')
				}
				if(descDoms[i]) {
					descDoms[i].setAttribute('class', 'item-desc')
				}
			}
		}
		
		for(let i=0; i<imageDoms.length; i++) {
			if(imageDoms[i].getBoundingClientRect().top < winHeight - imageDoms[i].clientHeight) {
				let proportion = 1 - (imageDoms[i].getBoundingClientRect().top / (winHeight - imageDoms[i].clientHeight))
				imageDoms[i].style.backgroundPositionY = 50 + 20 * proportion + '%'
			}
		}
	}
	
  useEffect(() => {
		let ScrollMagic, controller, scene, tl
		ScrollMagic = loadScrollMagic()
		controller = new ScrollMagic.Controller()
		tl = gsap.timeline()
		
		tl.add(gsap.to(topImageEl.current,{
		  scale: 1,
		}, 1))
		
		scene = new ScrollMagic.Scene({
		  triggerElement: rootNode.current,
		  triggerHook: 0,
		  offset: -window.innerHeight + (window.innerHeight/5)*2,
		  duration: window.innerHeight * 0.6
		})
		.setTween(tl)
		.addTo(controller)
		 
		window.addEventListener("scroll", onScroll)
		return () => {
			scene.destroy(true);
			scene = null;
			controller.destroy(true);
			controller = null;
			window.removeEventListener("scroll", onScroll)
		};
  }, []);
  
  const rootClasses = classNames("c-balanced-design", getOverallSettingsClasses(fields));
	const image = isMobile ? m_image : pc_image
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
			{image?.value?.src && <div className="top-image-content">
				<div className="top-image-innercontent" ref={topImageEl}>
					<BackgroundImage {...image} className="top-image" />
				</div>
			</div>}
			<div className="highlight-list-content" ref={listContentEl}>
				{list && list.map((item, index) => (
				  <div 
						className={["item", index%2 === 1 ? 'active' : ''].join(' ')}
						key={index}
						>
						<div className="background-image-content">
							<div className="background-image-innercontent">
								{!item?.fields?.video?.value && <BackgroundImage {...item.fields.image} className="item-image" />}
								{item?.fields?.video?.value && <video className="item-video" poster={item?.fields?.image?.value.src} autoPlay={true} muted={true} loop={true}>
									<source type={item.fields.video?.value?.mimeType} src={item.fields.video?.value?.src} />
								</video>}
							</div >
						</div>
						<div className="text-content">
							{!isMobile && <RichText tag="div" className="item-title" field={item.fields.pc_title} />}
							{isMobile && <RichText tag="div" className="item-title" field={item.fields.m_title} />}
							{!isMobile && <RichText tag="div" className="item-desc" field={item.fields.pc_desc} />}
							{isMobile && <RichText tag="div" className="item-desc" field={item.fields.m_desc} />}
						</div>
				  </div>
				))}
			</div>
    </div>
  )
};
export default BalancedDesign;
